module.exports = (fox) => {
	var _ = {
		STLABEL: '_nsls_',
		USECONFIRM: false,

		subscribeResponse: function (res) {
			var now = new Date().getTime();

			fox.utils.localStorage('setItem', _.STLABEL, now);
			this.hideNewsletterBlock();

			if (_.USECONFIRM === true) {
				this.rwom1('#confirmSubscription').show();
			}
		},

		visibility: function () {
			var m = fox.isEmpty(fox.site.member);
			var nsw = fox.getEnv('siteProps.newsLetterWidget');
			var lstl = fox.utils.localStorage('getItem', _.STLABEL);

			var pm = this.wom1('@root .PermissionManager');

			if (pm) {
				m = pm.hasAccess('guest') && fox.isEmpty(pm.getMemberInfo());
			}

			return m === true && nsw === '1' && !lstl;
		},
	};

	fox.registerWidget('NewsLetterSubscriber', {
		configure: function () {
			this.registerOptions('', {
				template: 'newsletterBlock',
				autoRender: true,
				widgets: {
					form: {
						widget: 'Form',
						loadValuesOnRun: false,
						formElements: {
							name: { element: '[name="name"]', autoApply: true },
							email: {
								element: '[name="email"]',
								autoApply: true,
								validate: [{ validator: 'regexp', options: { type: 'emailCaseInsensitive' }, message: 'Wrong email format' }]
							},
						},
						'methods.send': 'site.subscribeToNewsletter',
						submit: {
							target: '#subscribe-to-site',
							event: 'click'
						},
						'hooks.onSubmit': (...args) => this.submitForm(...args),
						'hooks.onResponse': function () { },
						'widgets.validator': {
							widget: 'Easy_Form_Validator',
							formWidget: '@parent',
							hangClassLocation: 'parentNode',
							requiredFields: ['name', 'email'],
							defaultValidator: [{
								validator: 'length',
								options: { min: 1 },
								message: 'Cannot be empty'
							}]
						}
					}
				},
				'handleWom.submited': {
					event: 'submit',
					widget: '#form',
					callback: function (values) {
						this.sbem = values.email;
					}
				},
				handleDom: {
					subscribeByEnter: {
						event: 'keyup',
						target: 'input',
						eventChecker: function (e) { return e.keyCode === 13 },
						callback: function () {
							this.rwom1('#form')._submit();
						}
					}
				}
			});

			if (_.USECONFIRM === true) {
				this.registerOptions('', {
					'widgets.confirmSubscription': {
						widget: 'Dialog',
						template: '',
						dialog: {
							closeText: ''
						},
						'widgets.body': {
							widget: 'Widget',
							autoRender: true,
							template: 'subscriptionConfirm'
						},
						'handleDom.close': {
							event: 'click',
							callback: 'hide',
							targetWidget: '#body'
						}
					}
				});
			}

			this.callParent('configure', arguments);
		},

		beforeEmbed: function () {
			if (_.visibility.call(this) === false) {
				return false;
			}

			return this.callParent('beforeEmbed', arguments);
		},

		hideNewsletterBlock: function () {
			var removeDelay = this.getOption('removeDelay');

			this.hookWrapper('beforeBlockRemove');

			if (removeDelay) {
				return setTimeout(fox.bind(this.removeFromDom, this), removeDelay);
			}

			return this.removeFromDom();
		},

		beforeBlockRemove: function () { },

		removeFromDom: function () {
			this.callParent('removeFromDom', arguments);

			this.dispatchEvent('removedFromDom');
		},

		submitForm: function (values) {
			const _this = this.rwom1('#form');
			const api = _this._getFormSendApi();

			api.psend(values)
				.then(fox.bind(_.subscribeResponse, _this.getParent()))
				.catch(fox.bind(function (res) {
					var fv = this.rwom1('#validator');

					fv.dispatchEvent('formNotValid', {
						errorStack: {
							email: [
								{ message: 'Arleady subscribed' }
							]
						}
					});

					fv.hangStyle('email');
				}, _this));

			_this.dispatchEvent('submit', values);
		}
	});
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/newsLetterSubscriber.es.js